import React from 'react';

const UserInfo = ({ fullname }) => {
  if (!fullname) return null;

  const getShortName = (fullname) => {
    if (!fullname) return '';
    const parts = fullname.trim().split(' ');
    if (parts.length === 1) return parts[0];
    // Ejemplo: "Juan Pablo González" => "Juan P. González"
    return `${parts[0]}${parts[1] ? ' ' + parts[1][0] + '.' : ''} ${parts[parts.length - 1]}`;
  };

  return (
    <div className="text-right text-gray-600 text-xs md:text-lg mb-2">
      <span className="font-semibold text-black">{getShortName(fullname)}</span>
    </div>
  );
};

export default UserInfo;
